module.exports = __webpack_public_path__ + "456d8ef3101fb54a5bc5c0bd040885ca.pdf";